import { InitialPaymentDetails } from '@/types/management.types'
import React from 'react'

interface PaymentDetailsProps {
  details?: InitialPaymentDetails | null
}

const PaymentDetails: React.FC<PaymentDetailsProps> = ({
  details = {
    customerName: 'Nombre',
    customerLastName: 'Apellido',
    quotedUnits: 1,
    amountToPay: '203616.18',
    reference: 'Pago inicial - Cotización',
    paymentDate: '22/Mayo/2025',
    quoteId: 'ID#2000540',
  },
}) => {
  const {
    customerName,
    customerLastName,
    quotedUnits,
    amountToPay,
    reference,
    paymentDate,
    quoteId,
  } = details || {}
  const formatCurrency = (value: string | number): string => {
    const numericValue = typeof value === 'string' ? parseFloat(value) : value
    if (isNaN(numericValue)) return '$0.00'

    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
    }).format(numericValue)
  }

  const fullReference = `${reference} ${quoteId} - ${paymentDate}`

  return (
    <div className="max-w-lg mx-auto">
      <div className="bg-white border border-olr-primary rounded-lg p-4 shadow-sm">
        <div className="space-y-4">
          {/* Nombre cliente */}
          <div className="flex items-center">
            <label className="text-sm font-semibold text-gray-900 w-5/12">
              Nombre cliente
            </label>
            <p className="text-sm text-gray-700">
              {customerName} {customerLastName}
            </p>
          </div>

          {/* Unidades cotizadas */}
          <div className="flex items-center">
            <label className="text-sm font-semibold text-gray-900  w-5/12">
              Unidades cotizadas
            </label>
            <p className="text-sm text-gray-700">{quotedUnits}</p>
          </div>

          {/* Monto a pagar */}
          <div className="flex items-center">
            <label className="text-sm font-semibold text-gray-900 w-5/12">
              Monto a pagar
            </label>
            <p className="text-sm text-gray-700 font-medium">
              {formatCurrency(amountToPay || 0)}
            </p>
          </div>

          {/* Referencia */}
          <div className="flex items-start">
            <label className="text-sm font-semibold text-gray-900 flex-shrink-0 w-5/12">
              Referencia
            </label>
            <p className="text-sm text-gray-700">{fullReference}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PaymentDetails
